/**
 * Service class for loading response data.
 * This class handles the loading of response data from a remote server and processes it using DataBridgeService.
 */
class ResponseDataLoaderService {
    /**
     * Constructs the ResponseDataLoaderService.
     * @param {Object} $http - AngularJS HTTP service.
     * @param {Object} $bridges - AngularJS bridges service.
     * @param {Object} $config - Configuration service.
     * @param {Object} DataBridgeService - Service for managing data bridges.
     */
    constructor($http, $bridges, $config, DataBridgeService) {
        this.$http = $http;
        this.$bridges = $bridges;
        this.$config = $config;
        this.DataBridgeService = DataBridgeService;
        this._logIdentifier = 'ResponseDataLoaderService';
        this.$logger = this.$bridges.logger();
        this._candidate = undefined;
        this._timeElapsed = undefined;
    }

    /**
     * Loads response data from the server.
     * @param {string} userUUID - The UUID of the user.
     * @param {string} schoolCode - The code of the school.
     * @param {string} responseFolderName - The name of the response folder.
     * @param {Function} onDataLoaded - Callback function to be called when data is loaded.
     */
    loadResponseData(userUUID, schoolCode, responseFolderName, onDataLoaded) {
        this.$logger.logEnter(this, 'loadResponseData');

        // Load response file via HTTP and callback
        this.$http.get(this.$config.getResponseFileURL(userUUID, schoolCode, responseFolderName)).then((response) => {
            this.DataBridgeService.initResponse();
            for (let key in response.data) {
                // SMELL: Hardcoded string comparison for keys 'candidate' and 'timeElapsed'
                if (key === 'candidate') {
                    this._candidate = JSON.parse(response.data[key]).data;
                } else if (key === 'timeElapsed') {
                    this._timeElapsed = JSON.parse(response.data[key]);
                } else {
                    let decodedVal = JSON.parse(response.data[key]);
                    this.DataBridgeService.put(key, decodedVal);
                }
            }

            // callback
            onDataLoaded();
        });
    }

    /**
     * Gets the candidate data.
     * @returns {Object|undefined} The candidate data.
     */
    getCandidate() {
        return this._candidate;
    }

    /**
     * Gets the time elapsed data.
     * @returns {Object|undefined} The time elapsed data.
     */
    getTimeElapsed() {
        return this._timeElapsed;
    }
}

export default ResponseDataLoaderService;